import { defineStore } from 'pinia'
import beApiClient from "@/src/be-api-client";
import {APIRoute, EP } from "@/src/endpoints";
import { handleErrors, makeRequest } from "@/src/utils";

export const useTxcStore = defineStore('transplant-centers', {
  state: ()=> {
    return {
      // lookup data
      transplantCenters: [],
      organGroups: [],
    }
  },
  actions: {
    // Generic load data method
    loadEntity(url, key, params = {}) {
      return new Promise((resolve, reject) => {
        beApiClient.get(url, params).then(response => {
          this[key] = response.data;
          resolve();
        }).catch(error => {
          const message = handleErrors(error);
          reject(message);
        });
      });
    },
    loadPaginatedEntity(url, key, params = {}) {
      return new Promise((resolve, reject) => {
        beApiClient.get(url, {
          headers: {'Accept': 'application/json'},
          params: params })
          .then(response => {
            this[key] = response.data;
            resolve(response.data);
        }).catch(error => {
          const message = handleErrors(error);
          reject(message);
        });
      });
    },
    

    // load transplant centres
    loadTransplantCentres() {
      return this.loadPaginatedEntity(APIRoute(EP.admin.transplant_centers.index), 'transplantCenters',{ all: true })
    },
    // load organ groups
    loadAllOrganGroups() {
      return this.loadPaginatedEntity(APIRoute(EP.admin.organ_groups.index), 'organGroups',{ all: true })
    },
    //load organ groups
    loadOrganGroups() {
      return this.loadEntity(APIRoute(EP.admin.organ_groups.index), 'organGroups')
    },
    loadAllTransplantCentres(params) {
      return makeRequest(beApiClient.get, APIRoute(EP.admin.transplant_centers.index), { params: params });
    },   
    loadTransplantCentre(id) {
      return makeRequest(beApiClient.get, APIRoute(EP.admin.transplant_centers.show, { id: id }));
    },
    loadTxcConfiguration(id) {
      return makeRequest(beApiClient.get, APIRoute(EP.admin.transplant_centers.configurations.index, { transplant_center_id: id }));
    },
    createTxcConfigurations(payload) {
      return makeRequest(beApiClient.post, APIRoute(EP.admin.transplant_centers.configurations.create), { txc_configs: payload });
    },
    updateTxcConfigurations(payload, id) {
      return makeRequest(beApiClient.patch, APIRoute(EP.admin.transplant_centers.configurations.update, { transplant_center_id: id }), { transplant_center_id: id, txc_configs: payload });
    }
  }
});